import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import PayCardPage from './PayCardPage';
import './PayCardPage.less';

export const prefix = 'bm-p-pay-card';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: PayCardPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
